import React from 'react';
import PropTypes from 'prop-types';
import styles from './RadioOrDropdownSelector.module.scss';
import { FormGroup, FormRadioGroup, Input, Select, Textarea } from '@snsw/react-component-library';

export const RadioOrDropdownSelector = (props) => {
  const {
    options,
    name = '',
    title = '',
    helpMessage = '',
    errorMessage = '',
    hasError = false,
    maxOptionsLengthForRadio = 5,
    value = '',
    onChange = () => {},
    showExtraInput = false,
    extraInputType = 'input',
    extraInputTitle = '',
    extraInputHelpMessage = '',
    extraInputErrorMessage = '',
    extraInputHasError = false,
    extraInputValue = '',
    onChangeExtraInput = () => {},
    id = '',
    ...restProps
  } = props;

  const displayRadioGroup = (options, title, helpMessage, errorMessage, hasError, onChange, value) => {
    //convert options key 'text' to 'label'
    let radioOptions = options.map((v) => {
      let option = {};
      option['label'] = v.text;
      option['value'] = v.value;
      return option;
    });

    return (
      <FormRadioGroup
        id={id}
        name={name}
        {...restProps}
        options={radioOptions}
        value={value}
        onChange={onChange}
        legend={title}
        helpMessage={helpMessage}
        errorMessage={errorMessage}
        hasError={hasError}
        vertical={true}
      />
    );
  };

  const displayDropdown = (options, title, helpMessage, errorMessage, hasError, onChange, value) => {
    return (
      <FormGroup
        id={id}
        {...restProps}
        name={name}
        label={title}
        helpMessage={helpMessage}
        errorMessage={errorMessage}
        hasError={hasError}
      >
        <Select
          {...restProps}
          placeholder="Please select"
          options={options}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          value={value}
        />
      </FormGroup>
    );
  };

  const displaySelector = (options, title, helpMessage, errorMessage, hasError, onChange, value) => {
    if (options.length > maxOptionsLengthForRadio) {
      return displayDropdown(options, title, helpMessage, errorMessage, hasError, onChange, value);
    } else {
      return displayRadioGroup(options, title, helpMessage, errorMessage, hasError, onChange, value);
    }
  };

  const displayExtraInput = (
    showExtraInput,
    extraInputType,
    title,
    helpMessage,
    errorMessage,
    hasError,
    onChange,
    value,
  ) => {
    return showExtraInput ? (
      <FormGroup
        id={id + '_other'}
        label={title}
        helpMessage={helpMessage}
        errorMessage={errorMessage}
        hasError={hasError}
        margin={{ top: 'lg' }}
      >
        {
          {
            input: <Input {...restProps} onChange={(e) => onChange(e.target.value)} value={value} />,
            textarea: (
              <Textarea
                {...restProps}
                onChange={(e) => onChange(e.target.value)}
                value={value}
                className={styles.textarea}
              />
            ),
          }[extraInputType]
        }
      </FormGroup>
    ) : null;
  };

  return (
    <>
      {displaySelector(options, title, helpMessage, errorMessage, hasError, onChange, value)}
      {displayExtraInput(
        showExtraInput,
        extraInputType,
        extraInputTitle,
        extraInputHelpMessage,
        extraInputErrorMessage,
        extraInputHasError,
        onChangeExtraInput,
        extraInputValue,
      )}
    </>
  );
};

RadioOrDropdownSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  helpMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
  maxOptionsLengthForRadio: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  showExtraInput: PropTypes.bool,
  extraInputType: PropTypes.string,
  extraInputTitle: PropTypes.string,
  extraInputHelpMessage: PropTypes.string,
  extraInputErrorMessage: PropTypes.string,
  extraInputHasError: PropTypes.bool,
  extraInputValue: PropTypes.string,
  onChangeExtraInput: PropTypes.func,
};
